<template>
  <div class="loading-view">
    <div class="loading-view__content">
      <div class="loading-view__icon-container">
        <Logo :type="logoType" size="60px" />
      </div>
      <ProgresBar :max="modulesCount" :current="count" />
    </div>
  </div>
</template>

<script>
import { Routes, Modules } from "@/constants";
import { mapState } from "vuex";

import Logo, { LogoTypes } from "@/components/Logo";
import ProgresBar from "@/components/ProgressBar";

export default {
  name: "LoadingView",
  data() {
    return {
      logoType: LogoTypes.SHIELD,
      modulesCount: Modules.total,
      count: 0
    };
  },
  components: {
    ProgresBar,
    Logo
  },
  computed: {
    ...mapState({
      loadedSettingsProgress: state => state.loadedSettingsProgress
    })
  },
  watch: {
    loadedSettingsProgress: function(val) {
      this.count = val.length;
    }
  },
  mounted() {
    if (this.loadedSettingsProgress.length === Modules.total) {
      this.$router.push(Routes.home.path);
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-view {
  display: block;
  height: 100%;
  width: 100%;

  &__icon-container {
    margin-bottom: spacer("m");
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100vh;
    justify-content: center;
    position: fixed;
    top: 0;
    width: 100vw;
  }
}
</style>
